export function redirectToDarkSite() {
  const isDarkSiteVisited = !sessionStorage.getItem("isDarkSiteVisited");

  if (isDarkSiteVisited) {
    window.location.href = process.env.NEXT_PUBLIC_DARK_SITE_URL || "";
    sessionStorage.setItem("isDarkSiteVisited", "true");
  }
}
